// src/config.js
// ─────────────────────────────────────────────────────────────
// Single source of truth for the backend URL.
// Priority: REACT_APP_API_URL env var (set in Vercel) → fallback to Render URL.
// This means the site keeps working even if the env var isn't set yet.
// For local backend testing, create a file called `.env.local` in the
// project root containing:  REACT_APP_API_URL=http://localhost:5000
// ─────────────────────────────────────────────────────────────

const API_URL = (process.env.REACT_APP_API_URL || "https://inelf-backend.onrender.com").replace(/\/+$/, "");

export { API_URL };
export default API_URL;
